import SVGInject from "@iconfu/svg-inject";


SVGInject(document.getElementsByClassName("js-SvgInject"));
document.addEventListener("DOMContentLoaded", function () {
    SVGInject(document.getElementsByClassName("js-SvgInject"));
});
